import React, { useState } from 'react';
import { Paper, Box, Tooltip, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useApiManager from '../../../../utils/Api/apiManager';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from '../../../ConfirmationDialog/ConfirmationDialog';
import ContactsDialog from './ContactsDialog';

const DeleteRow = ({ hover }) => (
    <Box sx={{ position: 'relative', width: '20px', height: '22px' }}>
        {hover && <DeleteIcon />}
    </Box>
);

const Contacts = ({ data, fetchContacts, accountId }) => {
    const { del } = useApiManager();
    const [hoveredRow, setHoveredRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openContactsDialog, setOpenContactsDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState('');

    const handleContactsOpenDialog = () => {
        setOpenContactsDialog(true);
    };

    const handleContactsCloseDialog = () => {
        setOpenContactsDialog(false);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmAction = () => {
        handleDelete();
        handleCloseDialog();
    };

    const handleDelete = async () => {
        try {
            const deletedRow = await del(`/leads/${currentRow.id}`);
            fetchContacts();
        } catch (error) {
            console.error('Error deleting task:', error);
        }
    };

    const handleAddContacts = () => {
        handleContactsOpenDialog();
    };

    return (
        <div>
            <Paper elevation={0} sx={{ p: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <h4>Contacts</h4>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="contained" onClick={handleAddContacts}>Add Contacts</Button>
                    </Box>
                </Box>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell width={10}>-</TableCell>
                                <TableCell width={100}>Contact Name</TableCell>
                                <TableCell align="right">Email</TableCell>
                                <TableCell align="right">Phone</TableCell>
                                <TableCell align="right">Mobile</TableCell>
                                <TableCell align="right">Fax</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((row) => (
                                <TableRow
                                    key={row.id}
                                    onMouseEnter={() => setHoveredRow(row.id)}
                                    onMouseLeave={() => setHoveredRow(null)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <Tooltip title="Delete">
                                        <TableCell sx={{ width: '20px', height: '22px', padding: '8px', cursor: 'pointer' }}
                                            onClick={() => {
                                                setCurrentRow(row);
                                                handleOpenDialog();
                                            }}>
                                            <DeleteRow hover={hoveredRow === row.id} />
                                        </TableCell>
                                    </Tooltip>
                                    <TableCell component="th" scope="row">
                                        <Link to={`/contacts/${row.id || ''}`}>
                                            {(row.firstName || '') + ' ' + (row.lastName || '')}
                                        </Link>
                                    </TableCell>
                                    <TableCell align="right">{row.email || '—'}</TableCell>
                                    <TableCell align="right">{row.phone || '—'}</TableCell>
                                    <TableCell align="right">{row.mobile || '—'}</TableCell>
                                    <TableCell align="right">{row.fax || '—'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <ConfirmationDialog
                    open={openDialog}
                    title="Confirm Action"
                    content="Are you sure you want to delete this item? This action will delete the entity and it cannot be undone!"
                    onClose={handleCloseDialog}
                    onConfirm={handleConfirmAction}
                    confirmText="Confirm"
                    cancelText="Cancel"
                />
            </Paper>
            <ContactsDialog open={openContactsDialog} setOpen={setOpenContactsDialog} accountId={accountId} fetchContacts={fetchContacts} />
        </div>
    )
}

export default Contacts;